import { render, staticRenderFns } from "./FeedTextItem.vue?vue&type=template&id=2571bd48&scoped=true&"
import script from "./FeedTextItem.vue?vue&type=script&lang=js&"
export * from "./FeedTextItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedTextItem.vue?vue&type=style&index=0&id=2571bd48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2571bd48",
  null
  
)

export default component.exports